/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { all } from 'redux-saga/effects'
import {
  fetchGroupSetEntitiesSaga,
  groupsPollingSaga,
  topSubGroupsRequestSaga,
  topSubGroupsPollingSaga
} from './api/groups/groupsSaga'
import { hubsRequestSaga, hubsPollingSaga } from './api/hubs/hubsSaga'
import { 
  openAlarmsRequestSaga, 
  openAlarmsPollingSaga,
  activeDevicesRequestSaga, 
  activeDevicesPollingSaga,
  roleDevicesRequestSaga,
  roleDevicesPollingSaga,
  topTechnologiesRequestSaga,
  topTechnologiesPollingSaga,
  topGroupsRequestSaga,
  topGroupsPollingSaga,
  topDevicesRequestSaga,
  topDevicesPollingSaga  

} from './api/home-screen/homeScreenSaga'
import { getWmiSaga,wmiPollingSaga,getsnmpSaga,snmpPollingSaga } from './api/DeviceDiscovery/credentials/catalogSaga'
import {getWmiSagaDetails} from './api/groupTrees/catalogSaga'
import { getUnixSaga,unixPollingSaga } from './api/DeviceDiscovery/unixCredentials/catalogUnixSaga'
import { getScopesSaga,scopesPollingSaga } from './api/DeviceDiscovery/scopes/catalogScopesSaga'
import { fetchReportFolderSaga } from './api/reports/reportsSaga'
import { watchFetchAccount, watchFetchAxaAccount } from './api/account/saga'
import { probesRequestSaga, probesPollingSaga } from './api/setup-wizard/setupWizardSaga'
import {agentsRequestSaga, agentsPollingSaga, agentsStatusRequestSaga, agentsStatusPollingSaga, jobsCountRequestSaga, jobsCountPollingSaga} from './api/DeviceDiscovery/agents/agentsSaga'
import {
  groupRequestSaga,
  profileRequestSaga,
  deviceRequestSaga,
  deviceByDeviceIdRequestSaga,
 

} from './api/mcsDashboard/groups/groupsSaga'
import {devicesRequestSaga,deviceProfilesRequestSaga,deviceProfilesByProfileIdRequestSaga} from './api/mcsDashboard/devices/devicesSaga'
import {getMaintenanceSaga,maintenancePollingSaga} from './api/maintenance/maintenanceSaga'
import { metricDeviceChartRequestSaga, metricDeviceChartPollingSaga } from './api/dashboardMetrics/dashboardMetricSaga'
export default function* rootSaga() {
  yield all([
    topSubGroupsRequestSaga(),
    topSubGroupsPollingSaga(),  
    activeDevicesRequestSaga(), 
    activeDevicesPollingSaga(),
    roleDevicesRequestSaga(),
    roleDevicesPollingSaga(),
    topTechnologiesRequestSaga(),
    topTechnologiesPollingSaga(),
    topGroupsRequestSaga(),
    topGroupsPollingSaga(),
    topDevicesRequestSaga(),
    topDevicesPollingSaga (),
    openAlarmsPollingSaga(),
    openAlarmsRequestSaga(),
    fetchGroupSetEntitiesSaga(),
    groupsPollingSaga(),
    hubsRequestSaga(),
    hubsPollingSaga(),
    fetchReportFolderSaga(),
    watchFetchAccount(),
    watchFetchAxaAccount(),
    probesRequestSaga(),
    probesPollingSaga(),
    getWmiSaga(),
    wmiPollingSaga(),
    getUnixSaga(),
    unixPollingSaga(),
    agentsRequestSaga(),
    agentsPollingSaga(),
    agentsStatusRequestSaga(),
    agentsStatusPollingSaga(),
    getScopesSaga(),
    scopesPollingSaga(),
    jobsCountPollingSaga(),
    jobsCountRequestSaga(),
    groupRequestSaga(),
    profileRequestSaga(),
    deviceRequestSaga(),   
    devicesRequestSaga(),
    deviceProfilesRequestSaga(),  
    deviceByDeviceIdRequestSaga(),
    deviceProfilesByProfileIdRequestSaga(),
    getWmiSagaDetails(),
    getsnmpSaga(),
    snmpPollingSaga(),
    getMaintenanceSaga(),
    maintenancePollingSaga(),
    metricDeviceChartRequestSaga(),
    metricDeviceChartPollingSaga(),
    
  ])
}
